import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllActivitiesByPlace } from 'domain/usecases/dashboard';

export class RemoteGetAllActivitiesByPlace implements GetAllActivitiesByPlace {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllActivitiesByPlace.Result>,
  ) {}

  async execute(
    params: GetAllActivitiesByPlace.Params,
  ): Promise<GetAllActivitiesByPlace.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        length: params.length,
        starts: params.starts,
        ends: params.ends,
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        groups: params.group,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
